/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import {
  restructureMenuItemModel,
  restructureContentModel,
  restructurePopularItemModel,
  restructureSearchItemModel
} from './restructuring';

const destructDataMenu = (state, data) =>
  _.keyBy(
    _.map(data, item => {
      const result = restructureMenuItemModel(state, item);
      if (_.get(item, 'childrens') && item.childrens.length > 0) {
        result.children = _.map(item.childrens, child =>
          restructureMenuItemModel(state, child)
        );
      } else {
        result.children = [];
      }
      return result;
    }),
    'id'
  );

class FaqContentsService {
  async getMenu(state) {
    const response = await api.get('/faq-contents/menu', {});
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: destructDataMenu(state, responseJson.data),
        itemsIds: _.map(responseJson.data, item => item.id)
      }
    };
  }

  async getPopular(state) {
    const response = await api.get('/faq-contents/popular', {});
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        header: _.map(responseJson.data.header, item =>
          restructurePopularItemModel(state, item)
        ),
        items: _.map(responseJson.data.items, item =>
          restructurePopularItemModel(state, item)
        )
      }
    };
  }

  async search(state, queryParams) {
    const response = await api.get('/faq-contents/search', {
      content: _.get(queryParams, 'content')
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data, item =>
            restructureSearchItemModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data, item => item.id)
      }
    };
  }

  async get(state, name) {
    const response = await api.get(`/faq-contents/get/${name}`, {
      expand: 'children,parent,beforeContentSeoUrl,nextContentSeoUrl'
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: _.keyBy(
        _.map([responseJson.data], item =>
          restructureContentModel(state, item)
        ),
        'seoUrl'
      )
    };
  }
}

export default new FaqContentsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/services/FaqContentsService/FaqContentsService.js